<template>
  <CModal :show.sync="show" centered>
    <template #header>
      <div class="d-flex">
        <CIcon name="cipUserSquare" size="custom-size" width="36" height="36"
               class="mr-3 icon-circle icon-circle--primary"/>
        <div class="align-self-center">
          <h5 class="modal-title">
            <translate translate-context="photo_search.generate_checkin_from_face">
              Generate Check-in from Face
            </translate>
          </h5>
        </div>
      </div>
      <CButtonClose @click="show = false"/>
    </template>

    <p class="text-muted mb-3" translate-context="photo_search.generate_checkin_from_face" v-translate>
      A check-in will be created for each detected face in the selected photos.
    </p>

    <div class="option-card">
      <CInputCheckbox custom
                      id="useFilenameAsEventTitle"
                      :checked="useFilenameAsEventTitle"
                      :label="$pgettext('photo_search.generate_checkin_from_face', 'Use photo filename as check-in title')"
                      @update:checked="useFilenameAsEventTitle = $event"/>
      <small class="text-muted d-block option-help" translate-context="photo_search.generate_checkin_from_face" v-translate>
        Each generated check-in will be titled with the original filename, without extension.
      </small>
    </div>

    <template #footer>
      <CButton @click="show = false" color="secondary" v-translate>Cancel</CButton>
      <PButton @click="onConfirm" color="primary" translate-context="photo_search.generate_checkin_from_face" v-translate>
        Generate
      </PButton>
    </template>
  </CModal>
</template>

<script>
import PButton from "@/components/PButton.vue";

export default {
  name: "GenerateCheckinFromFaceModal",
  components: {PButton},
  data() {
    return {
      show: false,
      useFilenameAsEventTitle: false,
    }
  },
  emits: ['confirm'],
  methods: {
    open() {
      this.show = true
      this.useFilenameAsEventTitle = false
    },
    async onConfirm() {
      await this.emitPromised('confirm', {use_filename_as_event_title: this.useFilenameAsEventTitle})
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
.option-card {
  background: #FAFAFA;
  border: 1px solid #E1DFFB;
  border-radius: 8px;
  padding: 12px 14px;
}

.option-help {
  margin-top: 4px;
  margin-left: 28px;
  line-height: 1.35;
}
</style>
